import React, {Component} from 'react';
import './App.scss';
import Router from "../router/Router";
import Header from "../components/header/Header";

class App extends Component {
  render() {
    return(
      <div id={'app'} className={'container-fluid p-0 content--canvas'}>
        <Header/>
        <Router/>
      </div>
    )
  }
}

export default App;
